// extracted by mini-css-extract-plugin
export default {"editorLayoutFullWidth":"styles_editorLayoutFullWidth__C47c6","editorLayoutPartialWidth":"styles_editorLayoutPartialWidth__DAJmM"};